// 말달리자 (Run Horses) engine types.
// Rules: docs/wireframes/run-horses/rule.md (2026-06-18 verified ruleset).
// 11x11 board, oasis at (5,5); 10 pieces/player; slide + knight moves;
// knights cannot land within Manhattan distance 2 of the oasis;
// first piece onto the oasis wins.

export const RUN_HORSES_BOARD_SIZE = 11;
export const RUN_HORSES_OASIS = { row: 5, col: 5 } as const;
/** Knights may not land on cells within this Manhattan distance of the oasis. */
export const RUN_HORSES_NO_KNIGHT_RADIUS = 2;
/** p1 = black (moves first), p2 = white. */
export const RUN_HORSES_PLAYERS = ["p1", "p2"] as const;
/** Total horses placed per player at setup. */
export const RUN_HORSES_PIECES_PER_PLAYER = 10;

export type RunHorsesPlayerId = (typeof RUN_HORSES_PLAYERS)[number];
export type RunHorsesCell = "empty" | RunHorsesPlayerId;
export type RunHorsesBoard = readonly (readonly RunHorsesCell[])[];
export type RunHorsesPhase = "playing" | "game-over";
export type RunHorsesMoveKind = "slide" | "knight";

export interface ValidationResult {
  readonly valid: boolean;
  readonly error?: string;
  readonly details?: Record<string, unknown>;
}

export interface RunHorsesPosition {
  readonly row: number;
  readonly col: number;
}

export interface RunHorsesPlayer {
  readonly playerId: RunHorsesPlayerId;
  readonly label: string;
  readonly color: "black" | "white";
}

export interface MoveAction {
  readonly type: "Move";
  readonly playerId: RunHorsesPlayerId;
  readonly from: RunHorsesPosition;
  readonly to: RunHorsesPosition;
  readonly kind: RunHorsesMoveKind;
}

export type RunHorsesAction = MoveAction;

export interface RunHorsesState {
  readonly gameId: string;
  readonly hostPlayerId: RunHorsesPlayerId;
  readonly players: readonly RunHorsesPlayer[];
  readonly phase: RunHorsesPhase;
  readonly board: RunHorsesBoard;
  readonly currentPlayerId: RunHorsesPlayerId;
  readonly moveNumber: number;
  readonly winnerId: RunHorsesPlayerId | null;
  readonly lastAction: RunHorsesAction | null;
}

export interface InitGameOptions {
  readonly gameId?: string;
  readonly hostPlayerId?: RunHorsesPlayerId;
  readonly firstPlayerId?: RunHorsesPlayerId;
}

// Complete-information game: the viewer state is the full state.
export type RunHorsesViewerState = RunHorsesState;
